<template>
  <div class="payment-selection-container">
    <div class="header-actions">
      <el-button round icon="el-icon-back" @click="$emit('back', 'type')">返回</el-button>
    </div>

    <div class="summary-section">
      <div class="total-amount"
        >訂單總計 <span class="highlight">NT$ {{ paymentInfo.total || 0 }}</span></div
      >
      <div class="method-label">{{ currentInfo.title }}</div>
    </div>
    <div class="content-wrapper">
      <div class="input-card">
        <div class="payment-status-label">付款狀態</div>
        <div class="payment-status-group">
          <el-radio-group v-model="paymentStatus" direction="vertical">
            <div class="status-radio-item unpaid" :class="{ active: paymentStatus === 'unpaid' }">
              <el-radio label="unpaid" value="unpaid">
                <span class="status-text">未付款</span>
              </el-radio>
            </div>
            <div class="status-radio-item paid" :class="{ active: paymentStatus === 'paid' }">
              <el-radio label="paid" value="paid">
                <span class="status-text">已付款</span>
              </el-radio>
            </div>
          </el-radio-group>
        </div>

        <el-form :disabled="!paymentInfo.invoiceSetting || paymentStatus !== 'paid'" label-position="top" :model="invoiceData" class="invoice-dialog">
          <el-form-item required>
            <template slot="label">
              <span :style="{ color: isNeedInvoice ? '#121931' : '#C8CBD3' }">
                開立類型
              </span>
            </template>
            <el-select v-model="invoiceData.taxType" placeholder="請選擇" style="width: 100%">
              <el-option label="個人" value="B2C" />
              <el-option label="公司" value="B2B" />
              <el-option label="捐贈發票" value="DONATE" />
            </el-select>
          </el-form-item>

          <el-form-item v-if="invoiceData.taxType === 'B2C'">
            <template slot="label">
              <span :style="{ color: isNeedInvoice ? '#121931' : '#C8CBD3' }">
                載具類別
              </span>
            </template>
            <el-select v-model="invoiceData.carrierType" style="width: 100%">
              <el-option label="無 (寄送電子發票至客戶 email)" value="" />
              <el-option label="手機條碼" :value="0" />
              <el-option label="自然人憑證條碼" :value="1" />
              <el-option label="ezPay 電子發票載具" :value="2" />
            </el-select>
          </el-form-item>

          <el-form-item v-if="invoiceData.taxType === 'B2C' && invoiceData.carrierType === 0" required>
            <template slot="label">
              <span :style="{ color: isNeedInvoice ? '#121931' : '#C8CBD3' }">載具編號</span>
            </template>
            <el-input v-model="invoiceData.CarrierNum" placeholder="格式：/ABCDEFG" maxlength="8" @input="invoiceData.CarrierNum = invoiceData.CarrierNum || ''" />
          </el-form-item>

          <el-form-item v-if="invoiceData.taxType === 'B2C' && invoiceData.carrierType === 1" required>
            <template slot="label">
              <span :style="{ color: isNeedInvoice ? '#121931' : '#C8CBD3' }">載具編號</span>
            </template>
            <el-input v-model="invoiceData.CarrierNum" placeholder="格式：AB12345678901234" maxlength="16" @input="invoiceData.CarrierNum = invoiceData.CarrierNum || ''" />
          </el-form-item>

          <el-form-item v-if="invoiceData.taxType === 'B2B'" required>
            <template slot="label">
              <span :style="{ color: isNeedInvoice ? '#121931' : '#C8CBD3' }">統一編號</span>
            </template>
            <el-input v-model="invoiceData.taxId" placeholder="請輸入 8 碼統一編號" maxlength="8" />
          </el-form-item>

          <el-form-item v-if="invoiceData.taxType === 'DONATE'" required>
            <template slot="label">
              <span :style="{ color: isNeedInvoice ? '#121931' : '#C8CBD3' }">捐贈碼</span>
            </template>
            <el-input v-model="invoiceData.LoveCode" placeholder="請輸入 3~7 碼數字" maxlength="7" />
            <a class="donate-code-link" href="https://www.einvoice.nat.gov.tw/portal/btc/btc603w/search" target="_blank" rel="noopener noreferrer">
              捐贈碼查詢
            </a>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content-wrapper">
      <div class="input-card">
        <template v-if="['StoreCredit', 'Atm'].includes(type)">
          <p class="input-guide">{{ type === 'StoreCredit' ? '請輸入信用卡末四碼' : '請輸入匯款帳號末五碼' }}</p>
          <el-input v-model="formData.code" placeholder="請輸入" class="custom-input m-b-30" :maxlength="type === 'StoreCredit' ? 4 : 5" />
        </template>

        <template v-else-if="type === 'Cash'">
          <p class="input-guide">是否確認客人已付現？</p>
        </template>

        <template v-else-if="['unspecified', 'StoreLinePay'].includes(type)">
          <p class="input-guide">{{ type === 'StoreLinePay' ? '是否確認付款' : '' }}</p>
        </template>

        <div class="button-group">
          <el-button round type="primary" class="btn-confirm" @click="handleSubmit">確認送出</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Step4OffLineForm',
  props: {
    paymentInfo: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: '',
    },
    containerId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      invoiceVisible: false,
      formData: { code: '' },
      invoiceData: {
        taxType: 'B2C',
        carrierType: '',
        CarrierNum: '',
        taxId: '',
        LoveCode: '',
      },
      isNeedInvoice: false,
      paymentStatus: 'unpaid',
      invoiceSetting: true, // 是否啟用發票模組
    }
  },
  computed: {
    currentInfo() {
      const maps = {
        StoreCredit: { title: '現場信用卡' },
        Atm: { title: '線下匯款' },
        Cash: { title: '現金付款' },
        StoreLinePay: { title: 'LINE Pay' },
        unspecified: { title: '不指定付款方式' },
      }
      return maps[this.type] || { title: '' }
    },
  },
  watch: {
    'invoiceData.taxType'(value) {
      if (value !== 'B2C') this.invoiceData.CarrierNum = ''
      if (value !== 'B2B') this.invoiceData.taxId = ''
      if (value !== 'DONATE') this.invoiceData.LoveCode = ''
    },
    'invoiceData.carrierType'() {
      this.invoiceData.CarrierNum = ''
    },
  },
  methods: {
    isValidCompanyBan(ban) {
      if (!/^\d{8}$/.test(ban)) return false

      const weights = [1, 2, 1, 2, 1, 2, 4, 1]
      const sum = ban
        .split('')
        .map((digit, index) => Number(digit) * weights[index])
        .reduce((acc, value) => acc + Math.floor(value / 10) + (value % 10), 0)

      return sum % 5 === 0
    },
    validateInvoiceData() {
      const { taxType, carrierType, CarrierNum, taxId, LoveCode } = this.invoiceData

      if (taxType === 'B2C' && carrierType === 0) {
        const barcodeRegex = /^\/[A-Z0-9.\-+]{7}$/
        if (!CarrierNum) {
          this.$message.warning('請輸入載具編號')
          return false
        }
        if (!barcodeRegex.test(CarrierNum)) {
          this.$message.warning('手機條碼格式錯誤，需為 / + 7 碼大寫英數或符號(. - +)')
          return false
        }
      }

      if (taxType === 'B2C' && carrierType === 1) {
        const naturalPersonRegex = /^[A-Z]{2}\d{14}$/
        if (!CarrierNum) {
          this.$message.warning('請輸入自然人憑證條碼')
          return false
        }
        if (!naturalPersonRegex.test(CarrierNum)) {
          this.$message.warning('自然人憑證條碼格式錯誤，需為 2 位大寫英文 + 14 位數字（共 16 碼）')
          return false
        }
      }

      if (taxType === 'B2B') {
        if (!taxId) {
          this.$message.warning('請輸入統一編號')
          return false
        }
        if (!this.isValidCompanyBan(taxId)) {
          this.$message.warning('統一編號格式錯誤，請輸入有效的 8 碼統編')
          return false
        }
      }

      if (taxType === 'DONATE') {
        if (!LoveCode) {
          this.$message.warning('請輸入捐贈碼')
          return false
        }
        if (!/^\d{3,7}$/.test(LoveCode)) {
          this.$message.warning('捐贈碼格式錯誤，需為 3~7 碼數字')
          return false
        }
      }

      return true
    },
    async handleSubmit() {
      const requestPaymentStatus = this.paymentStatus === 'paid' ? 'PAID' : 'UNPAID'

      // 僅在已付款時驗證發票資料
      if (requestPaymentStatus === 'PAID' && this.paymentInfo.invoiceSetting && !this.validateInvoiceData()) {
        return
      }
      // 僅在已付款時驗證線下付款必填欄位
      if (requestPaymentStatus === 'PAID' && ['StoreCredit', 'Atm'].includes(this.type)) {
        if (!this.formData.code) {
          this.$message.warning('請輸入必填付款資訊號碼')
          return
        }
        const expectedLength = this.type === 'StoreCredit' ? 4 : 5
        if (this.formData.code.length !== expectedLength) {
          this.$message.warning(`${this.type === 'StoreCredit' ? '信用卡' : '匯款帳號'}末${expectedLength}碼格式錯誤`)
          return
        }
      }

      try {
        const loading = this.$loading({ lock: true, text: '處理中...' })

        // 已付款才送發票資料
        const invoicePayload = requestPaymentStatus === 'PAID' ? this.buildInvoicePayload() : null

        // 發送 emit，包含付款方式和發票資訊
        this.$emit('fetchPayMethod', this.type, invoicePayload, requestPaymentStatus)

        loading.close()
      } catch (error) {
        console.error('提交失敗:', error)
        this.$message.error('系統忙碌中，請稍後再試')
      }
    },
    buildInvoicePayload() {
      // 僅當發票設定啟用時才構建發票資訊
      if (!this.paymentInfo.invoiceSetting) {
        return null
      }

      const { taxType, carrierType, CarrierNum, taxId, LoveCode } = this.invoiceData
      const invoice = {
        taxType,
      }

      // 根據 taxType 添加對應欄位
      if (taxType === 'B2C') {
        invoice.CarrierType = carrierType
        if (carrierType === 0 || carrierType === 1) {
          invoice.CarrierNum = CarrierNum
        }
      } else if (taxType === 'B2B') {
        invoice.taxId = taxId
      } else if (taxType === 'DONATE') {
        invoice.LoveCode = LoveCode
      }

      return invoice
    },
  },
}
</script>

<style lang="scss" scoped>
/* 承襲先前的橘色風格 */
.payment-selection-container {
  padding: 20px;
  background-color: #fcfcfc;

  .summary-section {
    text-align: center;
    margin-bottom: 30px;
    .total-amount {
      font-size: 1.2rem;
      .highlight {
        color: #ea6a2a;
        font-weight: bold;
      }
    }
    .method-label {
      margin-top: 10px;
      color: #666;
    }
  }

  .content-wrapper {
    margin-bottom: 20px;
  }

  .input-card {
    background: #fff;
    max-width: 600px;
    margin: 0 auto;
    padding: 20px 40px;
    border-radius: 8px;
    text-align: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);

    .invoice-toggle-row {
      padding-bottom: 20px;
      border-bottom: 1px solid #ebeef5;
      margin-bottom: 20px;
    }

    .payment-status-label {
      font-size: 14px;
      font-weight: 600;
      color: #121931;
      margin-bottom: 12px;
      text-align: left;
    }

    .payment-status-group {
      margin-bottom: 20px;
      display: flex;
      flex-direction: column;
      gap: 10px;

      ::v-deep .el-radio-group {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: stretch;
      }

      .status-radio-item {
        position: relative;
        padding: 12px 16px;
        border: 2px solid #e4e7ed;
        border-radius: 6px;
        transition: all 0.3s ease;
        cursor: pointer;
        background-color: #f5f7fa;

        &:hover {
          border-color: #ea6a2a;
          background-color: #fff8f4;
        }

        &.active {
          border-color: #ea6a2a;
          background-color: #fff8f4;
          box-shadow: 0 0 8px rgba(234, 106, 42, 0.15);

          .status-text {
            color: #ea6a2a;
            font-weight: 600;
          }
        }

        .status-text {
          color: #121931;
          font-weight: 500;
          font-size: 15px;
          transition: all 0.3s ease;
        }

        ::v-deep .el-radio {
          display: flex;
          align-items: center;
          width: 100%;

          .el-radio__inner {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            border: 2px solid #c8cbd3;
            background-color: #fff;
            transition: all 0.3s ease;
          }

          .el-radio__input.is-checked .el-radio__inner {
            border-color: #ea6a2a;
            background-color: #fff;

            &::after {
              width: 6px;
              height: 6px;
              background-color: #ea6a2a;
              border-radius: 50%;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              content: '';
              display: block;
            }
          }

          .el-radio__label {
            padding-left: 8px;
            font-size: 15px;
            margin-left: 0;
          }
        }
      }
    }

    .invoice-checkbox-wrapper {
      margin-top: 16px;
      padding-top: 16px;
      border-top: 1px solid #ebeef5;

      ::v-deep .el-checkbox {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .el-checkbox__inner {
          width: 18px;
          height: 18px;
          border-radius: 4px;
          background-color: #fff;

          &::after {
            height: 8px;
            width: 4px;
            left: 5px;
            top: 1px;
            border-width: 2px;
          }
        }

        .el-checkbox__label {
          padding-left: 8px;
          font-size: 15px;
          color: #121931;
          font-weight: 500;
        }
      }

      ::v-deep .el-checkbox.is-disabled {
        .el-checkbox__inner {
          background-color: #f5f7fa;
          border-color: #e4e7ed;
        }

        .el-checkbox__label {
          color: #c8cbd3;
        }
      }
    }

    // 統一處理 Checkbox 樣式
    ::v-deep .el-checkbox {
      display: flex;
      align-items: center;
      justify-content: center; // 讓整個控制項在卡片居中

      // 1. 放大方框本體
      .el-checkbox__inner {
        width: 20px !important; // 稍微加大到 20px 視覺效果更好
        height: 20px !important;
        border-radius: 4px; // 稍微圓角一點比較現代

        // 2. 精確定位內部的勾勾 (針對 20px 框計算)
        &::after {
          height: 10px !important;
          width: 5px !important;
          left: 6px !important; // 修正水平居中
          top: 2px !important; // 修正垂直居中
          border-width: 2px !important;
        }
      }

      // 3. 放大文字
      .el-checkbox__label {
        font-weight: 500;
        font-size: 18px !important; // 20px 框配 18px 字比較平衡
        line-height: 20px;
        padding-left: 10px;
      }
    }
    .input-guide {
      font-size: 1.1rem;
      color: #333;
      margin-bottom: 30px;
    }

    .custom-input ::v-deep .el-input__inner {
      height: 50px;
      text-align: center;
      font-size: 1.1rem;
    }

    .button-group {
      display: flex;
      flex-direction: column;
      gap: 16px;
      .el-button {
        width: 100%;
        height: 50px;
        margin: 0;
        font-size: 1rem;
      }
      .btn-confirm {
        background: #ea6a2a;
        border-color: #ea6a2a;
        color: #fff;
        margin-top: 16px;
      }
      .btn-later {
        color: #666;
        border-color: #dcdfe6;
      }
    }
  }
}

/* 針對發票彈窗的樣式 */
.invoice-dialog {
  .donate-code-link {
    display: inline-block;
    margin-top: 8px;
    font-size: 12px;
    color: #121212;
    text-decoration: underline;
  }

  .dialog-footer {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    .el-button {
      width: 100%;
      height: 45px;
      margin: 0;
    }
    .btn-confirm {
      background: #ea6a2a;
      border-color: #ea6a2a;
      color: #fff;
    }
  }
}
</style>
